module.exports = "https://static.wanderu.com/static/media/fr.c88df329.svg";